import { injectIntl } from 'react-intl';

const ModalHeader = ({ intl }) => {
  if (intl.locale === 'en') {
    return (
      <>
        <div className="text-weight-bold">Advanced cookie settings</div>
        <div className="mb-3">
          <a
            href="https://www.gov.br/pt-br/termos-de-uso"
            target="_blank"
            rel="noreferrer"
            className="text-weight-semi-bold"
          >
            See Cookies Statement
          </a>
        </div>
        <div className="mb-3">
          To improve your experience on the platform and provide personalized
          services, we use cookies.
        </div>
      </>
    );
  }

  return (
    <>
      <div className="text-weight-bold">Configurações avançadas de cookies</div>
      <div className="mb-3">
        <a
          href="https://www.gov.br/pt-br/termos-de-uso"
          target="_blank"
          rel="noreferrer"
          className="text-weight-semi-bold"
        >
          Ver Declaração de Cookies
        </a>
      </div>
      <div className="mb-3">
        Para melhorar a sua experiência na plataforma e prover serviços
        personalizados, utilizamos cookies.
      </div>
    </>
  );
};

export default injectIntl(ModalHeader);
